var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"symbol",style:([{'width': _vm.size},
              {'height': _vm.size},
              {'background-color': _vm.color},
              {'mask-image': 'url('+ require('@/assets/icons/'+_vm.icon+'.svg') +')'}])})}
var staticRenderFns = []

export { render, staticRenderFns }